import { render, staticRenderFns } from "./RegisterSimple.vue?vue&type=template&id=46b22852&"
import script from "./RegisterSimple.vue?vue&type=script&lang=js&"
export * from "./RegisterSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports